import { Routes } from '@angular/router';

import { isNewPasswordRequiredGuard } from './guards/is-new-password-required.guard';
import { isNotAuthenticatedGuard } from './guards/is-not-authenticated.guard';

export const AuthRoutes: Routes = [
  {
    path: 'email-sign-in',
    loadComponent: () => import('./email-sign-in/sign-in.component').then(m => m.EmailSignInComponent),
    canActivate: [isNotAuthenticatedGuard],
  },
  {
    path: 'temporary-password',
    loadComponent: () =>
      import('./temporary-password/temporary-password.component').then(m => m.TemporaryPasswordComponent),
    canActivate: [isNewPasswordRequiredGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./forgot-password/forgot-password-request/forgot-password-request.component').then(
        m => m.ForgotPasswordRequestComponent,
      ),
    canActivate: [isNotAuthenticatedGuard],
  },
  {
    path: 'password-reset',
    loadComponent: () =>
      import('./forgot-password/forgot-password-reset/forgot-password-reset.component').then(
        m => m.ForgotPasswordResetComponent,
      ),
    canActivate: [isNotAuthenticatedGuard],
  },
];
